import { ApiBase } from 'utils/api';


export default class BLApi {
    private base: ApiBase;

    constructor(base: ApiBase) {
        this.base = base;
    }

    getBLs = (id: number) => this.base.axios
        .get(`/api/voyages/${id}/bl`)
        .then(res => res.data);

    updateBL = (bls: any) => this.base.axios
        .put(`/api/bls/0`, {bls});

    deleteBL = (id: number) => this.base.axios
        .delete(`/api/bls/${id}`);

    extractCargo = (id: number) => this.base.axios
        .post(`/api/bls/extract/${id}`);

    splitBL = (id: number, type: string) => this.base.axios
        .post(`/api/bls/${id}/split/${type}`);

    setShipper = (id: number[], data: any) => this.base.axios
        .put('/api/bls/shipper/set', data, {params: {id}});

    deleteShipper = (id: number) => this.base.axios
        .delete(`/api/bls/${id}/shipper`);

    generate = (id: number, start: number) => this.base.axios
        .post(`/api/voyage/${id}/generate-bls`, {start});

    normalize = (id: number) => this.base.axios
        .post(`/api/voyage/${id}/normalize-bls`);

    getTypes = () => this.base.axios
        .get('/api/bl-types')
        .then(res => res.data);

    createType = (data: any) => this.base.axios
        .post('/api/bl-types', data)
        .then(res => res.data);

    updateType = (data: any) => this.base.axios
        .put(`/api/bl-types/${data.id}`, data)
        .then(res => res.data);

    deleteType = (id: number) => this.base.axios
        .delete(`/api/bl-types/${id}`);
}
